import * as types from 'modules/hardwares/actionTypes';
import type {
  FetchHardwaresSuccessAction,
  FetchUnassignedHardwaresSuccessAction,
  StoredHardware,
  UpdatedHardwareSuccessAction,
} from 'modules/hardwares/types';
import { hardwareCleaner } from 'modules/hardwares/utils';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';
import type { EntitySlice } from 'utils/ReduxUtils';

const hardwareAdapter = createEntityAdapter<StoredHardware>({ selectId: ({ hardwareId }) => hardwareId });

const addFromPage = (state: EntitySlice<StoredHardware>, { payload }: FetchHardwaresSuccessAction) =>
  hardwareAdapter.addMany(state, payload.content.map(hardwareCleaner));

const addFromArray = (state: EntitySlice<StoredHardware>, { payload }: FetchUnassignedHardwaresSuccessAction) =>
  hardwareAdapter.addMany(state, payload.map(hardwareCleaner));

const updateOne = (state: EntitySlice<StoredHardware>, { payload }: UpdatedHardwareSuccessAction) =>
  hardwareAdapter.updateOne(state, hardwareCleaner(payload));

export default createReducer(hardwareAdapter.getInitialState(), {
  [types.FETCH_HARDWARES_SUCCESS]: addFromPage,
  [types.FETCH_UNASSIGNED_HARDWARES_SUCCESS]: addFromArray,
  [types.LINK_HARDWARE_SUCCESS]: updateOne,
  [types.PATCH_STATUS_HARDWARE_SUCCESS]: updateOne,
});
